import * as THREE from "three";

class textureLoader {
    __loader(src) {
        return new Promise((resolve) => {
            const loader = new THREE.TextureLoader();
            loader.load(src, (texture) => {
                resolve(texture);
            });
        });
    }
}

export default textureLoader;